import React, { memo, useEffect, useLayoutEffect, useState } from "react";
import Navbar from "./navbar/Navbar";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./footer/Footer";
import { AuthProvider } from "@components/app/AuthProvider";
import { useSelector } from "react-redux";

function Layout(props) {
  const location = useLocation();
  const hideFooter = /^\/library\//.test(location.pathname);
  const isContentPage = /^\/library\//.test(location.pathname);
  const role = useSelector((state) => state.user.activeRole);
  const [bgColor, setBgColor] = useState("bg-white");

  useLayoutEffect(() => {
    switch (role) {
      case "school_admin":
        setBgColor("bg-school_admin");
        break;
      case "teacher":
        setBgColor("bg-teacher");
        break;
      case "student":
        setBgColor("bg-student");
        break;
      case "private_user":
        setBgColor("bg-private_user");
        break;
      case "superadmin":
        setBgColor("bg-superadmin");
        break;
      default:
        setBgColor("bg-white");
    }
  }, [role]);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div className="flex flex-col min-h-screen">
      <header className={`border-b border-b-[#00000033] ${bgColor}`}>
        <Navbar />
      </header>

      <main
        className={`flex-grow w-full  ${
          (location.state && location.state.url) || isContentPage
            ? "overflow-hidden"
            : `mx-auto desktop:px-6 max-w-[1248px] `
        }`}
      >
        <AuthProvider>
          <Outlet />
        </AuthProvider>
      </main>

      {!hideFooter && (
        <footer className="w-full" id={"footer"}>
          <Footer />
        </footer>
      )}
    </div>
  );
}

export default memo(Layout);
